/* Ficha de producto: galeria (tapa / disco / fotos, registro de plancha),
   cantidad, barra fija, aviso de reposicion en el mismo lugar, previews
   (un solo tema suena a la vez) y duracion por lado. */
const { mount, reduced, EASE } = window.EQ;

mount('[data-eq-pdp]', (root) => {
  const q = (s) => root.querySelector(s);
  const qa = (s) => Array.from(root.querySelectorAll(s));
  const lento = reduced();

  // ---- galeria: la principal no se reemplaza (foto de destino del morph);
  // las capas van encima y se destapan desde la linea de base --------------
  // Registro de plancha: la capa que ENTRA se destapa por ENCIMA de la que ya
  // se ve, que queda quieta; recien cuando la nueva cubre todo se retira la de
  // abajo. Si las dos animan a la vez, en el hueco asoma la portada.
  // Mientras hay una capa abierta la principal se oculta: si no, el borde
  // antialiasado de la capa deja ver una linea de la portada.
  // Los dos keyframes tienen que tener la MISMA cantidad de componentes.
  // Sangrado de 1px (recorte negativo): el borde del recorte cae fuera del
  // recuadro, que corta con overflow:hidden. Con inset(0) el antialiasado del
  // borde dejaba una linea del fondo abajo y a la derecha.
  const TAPADO = 'inset(100% -1px -1px -1px)', ABIERTO = 'inset(-1px -1px -1px -1px)';
  const principal = q('#eq-cover-slot > .eq-cover__img');
  const capas = qa('[data-eq-capa]');
  const capaDe = (k) => capas.find((c) => c.dataset.eqCapa === k) || null;
  // la foto tiene que estar decodificada ANTES de destaparse (son lazy)
  const lista = (capa) => {
    const im = capa && capa.querySelector('img');
    if (!im) return Promise.resolve();
    im.loading = 'eager';
    if (im.complete && im.naturalWidth) return Promise.resolve();
    return Promise.race([
      (im.decode ? im.decode() : Promise.resolve()).catch(() => {}),
      new Promise((r) => setTimeout(r, 400))
    ]);
  };
  let vistaActual = 'tapa', corrida = 0, zTop = 1;
  const verVista = async (k) => {
    if (k === vistaActual) return;
    const antes = vistaActual;
    vistaActual = k;
    qa('[data-eq-vista]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.eqVista === k ? 'true' : 'false'));
    const id = ++corrida;
    const entra = capaDe(k), sale = capaDe(antes);
    capas.forEach((c) => {
      c.getAnimations().forEach((a) => a.cancel());
      if (c !== entra && c !== sale) c.style.clipPath = TAPADO;
    });
    // vuelta a la tapa: la principal reaparece debajo y la capa se retira
    if (!entra) {
      if (principal) principal.style.visibility = '';
      if (!sale) return;
      sale.style.clipPath = TAPADO;
      if (!lento) sale.animate([{ clipPath: ABIERTO }, { clipPath: TAPADO }], { duration: 420, easing: EASE });
      return;
    }
    await lista(entra);
    if (id !== corrida) return;
    entra.style.zIndex = String(++zTop);
    entra.style.clipPath = ABIERTO;
    const asentar = () => {
      if (id !== corrida) return;
      if (sale) sale.style.clipPath = TAPADO;
      if (principal) principal.style.visibility = 'hidden';
    };
    if (lento) { asentar(); return; }
    entra.animate([{ clipPath: TAPADO }, { clipPath: ABIERTO }], { duration: 420, easing: EASE })
      .finished.then(asentar).catch(() => {});
  };
  // precarga en reposo: el primer cambio de foto ya encuentra el bitmap listo
  const precargar = () => capas.forEach((c) => { lista(c); });
  let tPre = 0;
  const onLoad = () => { tPre = window.requestIdleCallback ? requestIdleCallback(precargar, { timeout: 2000 }) : setTimeout(precargar, 800); };
  if (document.readyState === 'complete') onLoad(); else window.addEventListener('load', onLoad, { once: true });
  const onThumb = (e) => { const b = e.target.closest('[data-eq-vista]'); if (b) verVista(b.dataset.eqVista); };

  // ---- cantidad -----------------------------------------------------------
  const max = Math.max(1, Number(root.dataset.max) || 10);
  const cant = q('[data-eq-cantidad]');
  let n = 1;
  const pintar = () => { if (cant) cant.textContent = String(n); };
  const onMas = () => { if (n < max) { n++; pintar(); } };
  const onMenos = () => { if (n > 1) { n--; pintar(); } };
  q('[data-eq-mas]')?.addEventListener('click', onMas);
  q('[data-eq-menos]')?.addEventListener('click', onMenos);

  // ---- barra fija: aparece cuando la caja de compra sale de cuadro ---------
  const caja = q('[data-eq-caja]'), barra = q('[data-eq-barra]');
  let io = null;
  if (caja && barra) {
    io = new IntersectionObserver((ent) => {
      const fuera = !ent[0].isIntersecting && (window.scrollY || 0) > 320;
      barra.classList.toggle('is-on', fuera);
      barra.setAttribute('aria-hidden', fuera ? 'false' : 'true');
      // oculta = tambien fuera del Tab: aria-hidden con botones enfocables
      // adentro es un error de accesibilidad (Lighthouse / Agentic Browsing)
      barra.inert = !fuera;
    }, { rootMargin: '-120px 0px 0px 0px' });
    io.observe(caja);
  }

  // ---- aviso de reposicion (mismo lugar, sin modal) -----------------------
  const aviso = q('[data-eq-aviso]'), avisoOk = q('[data-eq-aviso-ok]'), form = q('[data-eq-aviso-form]'), mail = q('[data-eq-aviso-mail]');
  const irAlAviso = () => {
    if (!mail) return;
    const y = mail.getBoundingClientRect().top + (window.scrollY || 0) - 200;
    window.scrollTo({ top: Math.max(0, y), behavior: lento ? 'auto' : 'smooth' });
    setTimeout(() => { try { mail.focus({ preventScroll: true }); } catch (e) {} }, 420);
  };
  const onAviso = async (e) => {
    e.preventDefault();
    const v = ((mail && mail.value) || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { if (mail) mail.reportValidity(); return; }
    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    try {
      if (form.dataset.endpoint) {
        // app de back-in-stock con API propia (Klaviyo u otra): nuestro markup, su endpoint
        const r = await fetch(form.dataset.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ email: v, product: form.dataset.producto, variant: form.dataset.variante })
        });
        if (!r.ok) throw new Error('aviso');
      } else {
        const r = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
        if (!r.ok && r.status !== 302) throw new Error('aviso');
      }
      const ok = q('[data-eq-aviso-okmail]');
      if (ok) ok.textContent = v;
      if (aviso) aviso.hidden = true;
      if (avisoOk) avisoOk.hidden = false;
    } catch (err) {
      form.submit();
    } finally {
      if (btn) btn.removeAttribute('aria-busy');
    }
  };
  const onCambiar = () => { if (avisoOk) avisoOk.hidden = true; if (aviso) aviso.hidden = false; if (mail) mail.focus({ preventScroll: true }); };
  if (form) form.addEventListener('submit', onAviso);
  q('[data-eq-aviso-cambiar]')?.addEventListener('click', onCambiar);
  q('[data-eq-ir-aviso]')?.addEventListener('click', irAlAviso);
  // handoff desde la grilla: ?eqaviso=1 termina en el campo listo para escribir
  try { if (new URLSearchParams(location.search).get('eqaviso') === '1' && mail) setTimeout(irAlAviso, 260); } catch (e) {}

  // ---- previews: un solo tema suena a la vez ------------------------------
  let audio = null, sonando = null;
  const onPlay = (e) => {
    const b = e.target.closest('[data-eq-preview]');
    if (!b) return;
    if (sonando === b) { audio.pause(); return; }
    if (!audio) {
      audio = new Audio();
      audio.addEventListener('pause', () => { if (sonando) sonando.setAttribute('aria-pressed', 'false'); sonando = null; });
      audio.addEventListener('ended', () => { if (sonando) sonando.setAttribute('aria-pressed', 'false'); sonando = null; });
    }
    if (sonando) sonando.setAttribute('aria-pressed', 'false');
    audio.src = b.dataset.eqPreview;
    audio.play().then(() => { sonando = b; b.setAttribute('aria-pressed', 'true'); }).catch(() => {});
  };

  // ---- duracion por lado (se mide, no se escribe) ---------------------------
  qa('[data-eq-side-dur]').forEach((el) => {
    // el lado entero (antes closest('div') daba la cabecera del lado, sin temas
    // adentro: la duracion por lado nunca aparecia)
    const col = el.closest('.eq-tracks__lado');
    if (!col) return;
    let seg = 0, ok = true;
    col.querySelectorAll('[data-eq-dur]').forEach((d) => {
      const m = /^(\d+):(\d{2})$/.exec(d.textContent.trim());
      if (!m) { ok = false; return; }
      seg += Number(m[1]) * 60 + Number(m[2]);
    });
    if (ok && seg) el.textContent = Math.floor(seg / 60) + ':' + String(seg % 60).padStart(2, '0');
  });

  root.addEventListener('click', onThumb);
  root.addEventListener('click', onPlay);

  return () => {
    if (io) io.disconnect();
    if (audio) { audio.pause(); audio.src = ''; }
    root.removeEventListener('click', onThumb);
    root.removeEventListener('click', onPlay);
    window.removeEventListener('load', onLoad);
    corrida++;
    if (window.cancelIdleCallback) cancelIdleCallback(tPre); clearTimeout(tPre);
    if (form) form.removeEventListener('submit', onAviso);
  };
});
